import firebase from "firebase";
import uuid from "uuid";

function uniqFilename(filename) {
  const splitted = filename.split(".");
  if (splitted.length < 2) {
    throw new Error("Filename requires extension");
  }
  const fileId = uuid.v4();
  splitted.splice(splitted.length - 1, 0, fileId);
  return { filename: splitted.join("."), fileId };
}

export function uploadBlob(blob, filename, metadata) {
  const { filename: filenameUniq, fileId } = uniqFilename(filename);
  const customMetadata =
    metadata instanceof Object && Object.values(metadata).length
      ? { ...metadata, fileId }
      : { fileId };
  console.log("Filemetadata: ", customMetadata);

  return firebase
    .storage()
    .ref("attachments")
    .child(filenameUniq)
    .put(blob, {
      customMetadata
    });
}

export function uploadFile(file, metadata) {
  return uploadBlob(file, file.name, metadata);
}
